import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '../../../components/ui/alert-dialog'

interface UpsertTable {
  table: string
  key: string[]
}

interface UpsertConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  tables: UpsertTable[]
}

export function UpsertConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  tables
}: UpsertConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Confirm updates to existing rows</AlertDialogTitle>
          <AlertDialogDescription>
            Existing rows with the same key will be overwritten. New keys are still added.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="rounded-md border border-line bg-bg-sunk px-3 py-2 text-xs text-ink-2">
          <p className="font-medium text-ink">Tables that may change</p>
          <ul className="mt-1 list-disc space-y-1 pl-4">
            {tables.map((table) => (
              <li key={table.table}>
                <span className="font-mono">{table.table}</span>
                {table.key.length ? ` · key ${table.key.join(', ')}` : ''}
              </li>
            ))}
          </ul>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel size="sm">Cancel</AlertDialogCancel>
          <AlertDialogAction size="sm" onClick={onConfirm}>
            Confirm upsert
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
